'use strict';

var dateFns = require('date-fns');

function formatDuration({ start, end }) {
  const diffMonths = Math.abs(dateFns.differenceInCalendarMonths(start, end)) + 1;
  if (diffMonths < 1) {
    return "";
  }
  const yearCount = Math.floor(diffMonths / 12);
  const monthCount = diffMonths % 12;
  if (yearCount > 0 && monthCount > 0) {
    return `${yearCount}\uB144 ${monthCount}\uAC1C\uC6D4`;
  } else if (yearCount > 0) {
    return `${yearCount}\uB144`;
  } else if (monthCount > 0) {
    return `${monthCount}\uAC1C\uC6D4`;
  }
}

module.exports = formatDuration;
//# sourceMappingURL=formatDuration.cjs.map
